<!-- =========================================================================================
    File Name: ForgotPassword.vue
    Description: FOrgot Password Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>

  <div class="h-screen flex w-full" style="background-color: #262d4a" id="page-login" ref="resetpassword">
    <div class="vx-col sm:w-1/2 md:w-2/5 lg:w-2/5 xl:w-1/4 mx-auto self-center">
      <img style="width:100%;" :src="siteLogoUrl" />
      <vx-card card-background="#11193f" class="glow-effect_white">
        <p style="color: rgb(150, 150, 150); font-weight: 600; font-family: Montserrat;font-size: 16px;" class="mb-3 mt-1">Send reset password email</p>
        <vx-input-group id="email_inputgroup" class="mb-4">
          <template slot="prepend">
            <div class="prepend-text school-primary_gradient">
              <span><feather-icon class="pt-1" id="user-email-icon" icon="UserIcon" svg-classes="stroke-current"></feather-icon></span>
            </div>
          </template>

          <vs-input id="email_input"
                    v-validate="'required|email'"
                    name="email"
                    color="#52b75d"
                    autocomplete="off"
                    onClick="this.select();"
                    placeholder="Email"
                    v-model="inputEmail"
                    class="w-full no-icon-border theme-dark"
                    size="large" />
        </vx-input-group>

        <div class="pb-12 pt-3">
          <vs-button color="warning" style="border-radius:12px" type="border" ref="reset" class="mt-2 float-right vs-con-loading__container ml-3" @click="$router.push('/login');"><strong>Back</strong></vs-button>
          <vs-button style="border-radius:12px" ref="login" class="mt-2 float-right vs-con-loading__container school-primary_gradient" @click="reset"><img style="float:left; margin-left:-7px; margin-right:5px; margin-top:-2px; height:20px" src="https://lateralscaffolding.blob.core.windows.net/resources/icon-login-hover.png" /><strong>Reset</strong></vs-button>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        inputEmail: "",
        emailSent: false,
        errorOccurred: false
      };
    },
    computed: {
      siteLogoUrl: function() {
        if (this.$store.state.schoolTheme == "digi") {
          return "https://lateralscaffolding.blob.core.windows.net/resources/logo-if-on-white.png";
        }
        else if (this.$store.state.schoolTheme == "wced") {
          return "https://lateralscaffolding.blob.core.windows.net/resources/wced-logo.gif";
        }
      }
    },
    methods: {
      reset() {
        var self = this;

        self.$validator.validate('email').then(result => {
          if (result) {
            var encodedEmail = encodeURIComponent(self.inputEmail);
            //Make ajax call to api
            self.$ajaxGetAnon(self,`User/ResetPassword?email=${encodedEmail}`, function () {
              self.$router.push('/login');
              self.$vs.notify({
              title: 'Email Sent',
              color: "success",
              text: "The email has been sent to: " + self.inputEmail,
              position: 'top-right',
              iconPack: 'feather',
              icon: 'icon-success'
            });
            });
            //Show reset notification
          }
          else {
            self.$vs.notify({
              title: 'Attention',
              color: "warning",
              text: self.$validator.errors.items[0].msg,
              position: 'top-right',
              iconPack: 'feather',
              icon: 'icon-info'
            });
          }
        })
      },
      showLoadingOnElement(element, scale, type) {
        var self = this;
        self.$vs.loading({
          color: "#59BA4C",
          type: type,
          container: self.$refs[element].$el,
          scale: scale
        });
      },
    },
    mounted() {
      if (this.$route.params && this.$route.params.emailParam)
        this.inputEmail = this.$route.params.emailParam;
    }
  };
</script>